import React, { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ContentBox from '../../common/ContentBox/ContentBox';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import { AppContext } from '../../../App.context';
import styles from './DefaultLegalDocuments.styles';
import useDefaultLegalDocumentsHook from './DefaultLegalDocuments.hook';
import InfoView from 'Components/common/InfoView/InfoView';
import { InfoCircleOutlined } from '@ant-design/icons';

export default function DefaultLegalDocuments() {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const { state, actions } = useDefaultLegalDocumentsHook();

  const navigate = useNavigate();

  const checkboxRoutes = {
    dataPrivacyPolicy: '/legal/data-privacy-policy',
    loyaltyProgram: '/legal/loyalty-program',
    dataComercialUse: '/legal/data-commercial-use',
  };

  const legalTextRoutes = {
    entryPart: 'legal/custom_cardex_pdf',
    contract: '/legal/terms',
    entranceRegistration: '/legal/cardex',
  };

  const checkboxLabels = [
    { key: 'dataPrivacyPolicy', id: 'privacy' },
    { key: 'loyaltyProgram', id: 'loyalty' },
    { key: 'dataComercialUse', id: 'commercial' },
  ];

  const handleRedirect = path => {
    navigate(path);
  };

  return (
    <DefaultLayout>
      <ContentBox noPadding title={translate('legalDocuments.checkboxes')}>
        <div style={{ ...styles.contentWrapper }}>
          <p style={styles.infoText}>{translate('legalDocuments.info.checkBoxes')}</p>

          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.documentType')}
            </label>
          </div>
          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.documentNumber')}
            </label>
          </div>
          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.name')}
            </label>
          </div>
          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.surname')}
            </label>
          </div>
          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.secondSurname')}
            </label>
          </div>
          <div style={styles.checkinFields}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              {translate('policeReport.detailFields.address')}
            </label>
          </div>

          <div style={styles.checkboxContainer}>
            {checkboxLabels.map(({ key, id }, idx) => (
              <div key={idx} style={styles.checkboxItem}>
                <input type="checkbox" id={`check-${id}`} />
                <label htmlFor={`check-${id}`} style={styles.checkboxLabel}>
                  {translate(`legalDocuments.${key}`)}{' '}
                  <a
                    href="#"
                    style={styles.viewLink}
                    onClick={e => {
                      e.preventDefault();
                      handleRedirect(checkboxRoutes[key]);
                    }}
                  >
                    ({translate('legalDocuments.view')})
                  </a>
                </label>
              </div>
            ))}
          </div>

          <div style={styles.disabledButton}>{translate('legalDocuments.continue')}</div>
        </div>
      </ContentBox>
      <ContentBox noPadding title={translate('legalDocuments.legalTexts.title')}>
        <div style={styles.contentWrapper}>
          <p style={styles.infoText}>{translate('legalDocuments.info.legalTexts')}</p>

          <div style={styles.sectionBox}>
            <strong>{translate('legalDocuments.legalTexts.contract')}</strong>
            <button
              style={styles.sectionButton}
              onClick={() => handleRedirect(legalTextRoutes.contract)}
            >
              {translate('legalDocuments.legalTexts.viewContract')}
            </button>
          </div>

          <div style={styles.sectionBox}>
            <strong>{translate('legalDocuments.legalTexts.entranceRegistration')}</strong>
            <button
              style={styles.sectionButton}
              onClick={() => handleRedirect(legalTextRoutes.entranceRegistration)}
            >
              {translate('legalDocuments.legalTexts.viewEntranceRegistration')}
            </button>
          </div>

          <div style={styles.signatureContainer}>
            <label style={styles.signatureLabel}>{translate('legalDocuments.contractSign')}</label>
            <div style={styles.signatureBox}></div>
          </div>

          <div style={styles.disabledButton}>{translate('legalDocuments.sign')}</div>
        </div>
      </ContentBox>
      <ContentBox noPadding title={translate('legalDocuments.checkIn')}>
        <div style={styles.contentWrapper}>
          <Link to="/legal/custom_cardex_pdf" style={{ textDecoration: 'none', color: 'inherit' }}>
            <InfoView
              text={translate('legalDocuments.info.checkIn')}
              icon={<InfoCircleOutlined />}
            />
          </Link>
        </div>
      </ContentBox>
    </DefaultLayout>
  );
}
